import { inject, Injectable } from '@angular/core';
import { InternetProductResponseService } from '../../../order-api-response/internet-pd-response.service';
import { OrderCustomizationSubPayload } from '../../../../../../../models/order/workflow/order-customization.model';
import { OrderSelectedCustomization } from '../../../../../../../models/order/api-models/order-pd-response.model';
import { OrderFlowType } from '../../../../../../../models/order/order.model';


@Injectable({
    providedIn: 'root'
})
export class EarthlinkInternetCustomizationStateService {
    private internetPdResponseService = inject(InternetProductResponseService);

    buildCustomizationPayload(orderSelectedCustomizations: OrderSelectedCustomization[]): OrderCustomizationSubPayload[] | null {
        const updateComponent = this.internetPdResponseService.getUpdateOfferProductComponent();
        const originalComponent = this.internetPdResponseService.getProductComponent();
        const internetComponent = updateComponent ?? originalComponent;
        if (!internetComponent) return null;

        if (internetComponent) {
            const customizations = [];
            internetComponent.Customizations?.Customization.forEach(cust => {
                let hasCustomization = false;
                if (cust.Choices?.Choice?.length) {
                    cust.Choices?.Choice.forEach(choice => {
                        const rootPayload: OrderCustomizationSubPayload = {
                            Choice: choice.ChoiceCode || '',
                            Code: cust.CustomizationCode || '',
                            Customizations: [],
                            Usoc: choice.Usoc || ''
                        };

                        if (choice.Customizations?.Customization?.length) {
                            choice.Customizations?.Customization.forEach(nestedCust => {
                                if (nestedCust.Choices?.Choice?.length) {
                                    nestedCust.Choices?.Choice.forEach(nestedChoice => {
                                        const isSelected = orderSelectedCustomizations.filter(x => x.type === OrderFlowType.Internet).find(selCust => selCust.choice?.ChoiceCode === nestedChoice.ChoiceCode);
                                        if (isSelected) {
                                            rootPayload.Customizations.push({
                                                Choice: isSelected.choice?.ChoiceCode || '',
                                                Code: isSelected.customization?.CustomizationCode || '',
                                                Usoc: isSelected.choice?.Usoc || '',
                                            });
                                            hasCustomization = true;
                                        }
                                    });
                                }
                            });
                        }
                        if (hasCustomization) {
                            customizations.push(rootPayload);
                        }
                    });
                }
            })

            return customizations.length > 0 ? customizations : null;
        }

        return null;

    }
}
